var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_vm._l(([1, 2, 3, 4, 5]),function(index){return [_c('v-col',{key:index,staticClass:"mb-2",attrs:{"cols":"6","md":"3","lg":"3","xl":"2"}},[_c('site-card-loader')],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }